import { useState } from 'react';
import { CalendarOutlined, TableOutlined } from '@ant-design/icons';
import { useGetAppointmentSlotList } from 'src/hooks/frontdesk';
import { Card, Segmented } from '@insight-health-ai/roseate/components';
import AppointmentSlotCalendarView from './calendarView';
import { AppointmentSlotTableView } from './tableView';

type ViewType = 'calendar' | 'table';

export const AppointmentSlotList = () => {
  const { isLoading } = useGetAppointmentSlotList();
  const [viewType, setViewType] = useState<ViewType>('calendar');

  return (
    <div className="page-wrapper care-connect-page flex flex-col gap-4 h-full">
      <Card
        padding={viewType === 'table' ? { body: 'none' } : 'md'}
        loading={isLoading}
        title={
          <div className="flex items-center gap-2 justify-between">
            Appointment Slots
            <Segmented
              options={[
                {
                  label: 'Calendar',
                  value: 'calendar',
                  icon: <CalendarOutlined />,
                },
                { label: 'Table', value: 'table', icon: <TableOutlined /> },
              ]}
              value={viewType}
              onChange={(value) => setViewType(value as ViewType)}
            />
          </div>
        }
      >
        {viewType === 'calendar' ? (
          <AppointmentSlotCalendarView />
        ) : (
          <AppointmentSlotTableView />
        )}
      </Card>
    </div>
  );
};
